import Rest from '@/services/Rest';

/**
 * @typedef {BankService}
 */
export default class BankService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/infusion-soft'
}
